import { createDefaultSessionProvider } from '@coursera/event-pulse/core';

export default createDefaultSessionProvider();
